import { z } from 'zod';
const DemandeComplementPiecesSchema = z.object({
    id: z.string(),
    pieces: z.array(z.object({
        reference: z.string(),
        libelle: z.object({
            value: z.string(),
        }),
        documents: z.array(z.object({
            href: z.string(),
            id: z.string(),
            title: z.string(),
        })),
    })),
});
//# sourceMappingURL=demandes-complement-pieces.js.map